<template>
  <div class="down">
    <div class="down__body">
      <div class="down__body_logo"></div>
      <div class="down__body_cont">
        <h5>使用客户端</h5>
        <p>获得更便捷、更优质的体验</p>
        <el-button class="button-down" @click="isShowCode = !isShowCode">立即下载</el-button>
      </div>
    </div>
    <div class="down__code" v-if="isShowCode" @click="isShowCode = !isShowCode">
      <div class="code_img"></div>
      <h3>扫描二维码下载</h3>
      <h5>请使用手机自带浏览器扫码</h5>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShowCode: false
    }
  }
}
</script>
<style lang="scss" scoped>
  .down {
    width: 206px;
    position: relative;
    margin-top: 100px;
    transition: all 1s;
    &__body {
      width: 204px;
      height: 272px;
      border-radius: 4px;
      background-color: #f7f7f7;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 30px;
      margin-left: 1px;
      &_logo {
        width: 108px;
        height: 108px;
        background: url('https://img-shop.qmimg.cn/s1000184/images/2020/06/01/45212516d0c12c6e.png') center no-repeat;
        background-size: 100% auto;
      }
      &_cont {
        display: flex;
        flex-direction: column;
        text-align: center;
        h5 {
          font-size: 16px;
          color: #666;
          margin: 15px 0 10px;
        }
        p {
          font-size: 12px;
          color: #999;
        }
        .button-down {
          width: 145px;
          margin-top: 10px;
        }
      }
    }
    &__code {
      position: absolute;
      top: -34px;
      left: 0;
      width: 206px;
      height: 260px;
      background: url('https://img-shop.qmimg.cn/s1000184/images/2020/06/02/5b896c5740255bf7.png') center no-repeat;
      background-size: 100% auto;
      display: flex;
      flex-direction: column;
      line-height: 1.5;
      padding: 25px 30px 0;
      .code_img {
        display: inline-block;
        width: 146px;
        height: 146px;
        background:url('https://img-shop.qmimg.cn/s1000184/images/2020/06/02/87935e0e674687b4.png') center no-repeat;
        background-size: 146px 146px;
      }
      h3 {
        font-size: 16px;
        color: #333;
        text-align: center;
        font-weight: normal;
        margin: 6px 0 3px;
      }
      h5 {
        font-size: 12px;
        font-weight: normal;
        color: #999;
      }
    }
  }
</style>